module.exports = "/_next/static/images/img__card-6-touch-bf0fbded64979b3c879469eb71e885cc.png";